<app-eform-spinner>
  <router-outlet>
  </router-outlet>
</app-eform-spinner>
